import type { ReactNode } from "react";

export function QuotesLineItemText1({ children }: { children: ReactNode }) {
  return (
    <div className="text-[14px] font-light text-foreground">{children}</div>
  );
}
